var _g;
function _extends() { return _extends = Object.assign ? Object.assign.bind() : function (n) { for (var e = 1; e < arguments.length; e++) { var t = arguments[e]; for (var r in t) ({}).hasOwnProperty.call(t, r) && (n[r] = t[r]); } return n; }, _extends.apply(null, arguments); }
import * as React from "react";
function SvgSpecialist(_ref, svgRef) {
  let {
    title,
    titleId,
    ...props
  } = _ref;
  return /*#__PURE__*/React.createElement("svg", _extends({
    xmlns: "http://www.w3.org/2000/svg",
    width: 52,
    height: 53,
    viewBox: "0 0 52 53",
    ref: svgRef,
    "aria-labelledby": titleId
  }, props), title ? /*#__PURE__*/React.createElement("title", {
    id: titleId
  }, title) : null, _g || (_g = /*#__PURE__*/React.createElement("g", {
    fill: "#7742F5",
    fillRule: "nonzero",
    transform: "translate(.106 .506)"
  }, /*#__PURE__*/React.createElement("ellipse", {
    cx: 25.463,
    cy: 25.759,
    opacity: 0.102,
    rx: 25.463,
    ry: 25.759
  }), /*#__PURE__*/React.createElement("path", {
    d: "M35.04 33.633l-4.268-4.316a8.569 8.569 0 0 0 1.655-5.068c0-4.724-3.787-8.555-8.457-8.555-4.67 0-8.456 3.83-8.456 8.555 0 4.724 3.786 8.555 8.456 8.555a8.336 8.336 0 0 0 5.009-1.674l4.267 4.317a1.26 1.26 0 0 0 1.793 0 1.29 1.29 0 0 0 0-1.814zm-16.828-9.239c0-3.292 2.648-5.97 5.902-5.97s5.902 2.678 5.902 5.97-2.648 5.97-5.902 5.97-5.902-2.678-5.902-5.97z"
  }))));
}
const ForwardRef = /*#__PURE__*/React.forwardRef(SvgSpecialist);
export default __webpack_public_path__ + "static/media/specialist.d223cb322e894c86bb051d10c2dde699.svg";
export { ForwardRef as ReactComponent };